// extracted by mini-css-extract-plugin
module.exports = {"container":"drop_surface-module--container--v5CRY","hover":"drop_surface-module--hover--3GPhQ"};